var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 252,
    viewBox: "0 0 448 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 252,
    fill: "#868E96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.333 111H209.667C207.826 111 206.333 112.492 206.333 114.333V131C206.333 132.841 207.826 134.333 209.667 134.333H236.333C238.174 134.333 239.667 132.841 239.667 131V114.333C239.667 112.492 238.174 111 236.333 111Z",
    stroke: "#ECECEC",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.333 141H229.667",
    stroke: "#ECECEC",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223 134.333V141",
    stroke: "#ECECEC",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoThumbnail);
export default __webpack_public_path__ + "static/media/NoThumbnail.c11442c7af329fea6c5101e59b0a132e.svg";
export { ForwardRef as ReactComponent };